import axios from "axios";

// A single app-wide signal fired whenever the backend awards Stars to a learner,
// so the global Level-Up celebration can re-check the learner's level. We catch
// EVERY star-earning path with ONE axios response interceptor instead of adding
// a dispatch to each of the ~15 places that call the star endpoints.
export const STARS_EARNED_EVENT = "iw:stars-earned";

// URL fragments of endpoints that grant Stars / progress.
const STAR_URLS = [
  "/stars/add",
  "/arcade/game-result",
  "/arcade/daily-challenge/complete",
  "/founder/gift/", // gift claims grant stars/levels: /founder/gift/{id}/claim
];

let installed = false;

export function installStarEvents() {
  if (installed) return;
  installed = true;
  axios.interceptors.response.use(
    (res) => {
      try {
        const url = res?.config?.url || "";
        const method = (res?.config?.method || "").toLowerCase();
        const isClaim = url.includes("/founder/gift/") && url.includes("/claim");
        const isStarUrl = STAR_URLS.some((u) => url.includes(u)) && !url.includes("/founder/gift/");
        if (method === "post" && (isStarUrl || isClaim)) {
          window.dispatchEvent(new CustomEvent(STARS_EARNED_EVENT, { detail: { url } }));
        }
      } catch { /* SSR / non-browser safe */ }
      return res;
    },
    (err) => Promise.reject(err),
  );
}
